export const path = {

  methods: {
    replacePath(cognito,realms,path) {
        var replacePath = ''
        if(!cognito.isUseCognito){
          replacePath = '/' + realms + path
        } else {
          replacePath = path
        }
        return replacePath
    }
  }
}